export const language: any = {
    LabelCarts: "शॉपिंग कार्ट",
    Material: "सामग्री",
    nodata: "कार्ट में कोई डेटा नहीं",
};

